$(function () {

    function updateTextOnResize(screenWidth, selector) {
        // Проверка ширины экрана
        if ($(window).width() < screenWidth) {
            // Проходим по всем ссылкам, соответствующим селектору
            $(selector).each(function() {
                var trunkText = $(this).data('trunk-text'); // Получаем значение атрибута data-trunk-text
                if (trunkText) {
                    $(this).text(trunkText); // Заменяем текст на значение из data-trunk-text
                }
            });
        }
    }

    function deviceDetect() {
        $div = $('.container-test');
        if ($(this).width() <= 576) {
            //$div.css('background-color', '#F8EDBA').text('[' + $(this).width() + ']: NO: portrait mobile (< 576px)');
        } else if ($(this).width() <= 768 && $(this).width() > 576) {
            //$div.css('background-color', '#FAE792').text('[' + $(this).width() + ']: SM: landscape mobile (576px - 768px)');
        } else if ($(this).width() <= 992 && $(this).width() > 768) {
            //$div.css('background-color', '#F9EA6B').text('[' + $(this).width() + ']: MD: portrait tablets (768px - 992px)');
        } else if ($(this).width() <= 1200 && $(this).width() > 992) {
            //$div.css('background-color', '#FDE31A').text('[' + $(this).width() + ']: LG: landscape tablets (992px - 1200px)');
        } else if ($(this).width() <= 1400 && $(this).width() > 1200) {
            //$div.css('background-color', '#E2C010').text('[' + $(this).width() + ']: XL: laptops (1200px - 1400px)');
        } else if ($(this).width() > 1400) {
            //$div.css('background-color', '#BBA90F').text('[' + $(this).width() + ']: XXL: desktops (> 1400px)');
        }
    }

    updateTextOnResize(991, '.tablist__item a');
    updateTextOnResize(576, '.bx-header__links_text');

    deviceDetect();
    $(window).on('resize', deviceDetect);
});